import { useEffect, useState } from 'react'
import { AuthServices } from '../util/authServices';

const Filtros = ({ toast, setOpenMenuFilter, setScortObjectList, setControlLoadTarjetScort, setCargando }) => {

    const listOptionsEdad = ["Seleccione", "18", "19", "20", "21", "22", "23", "24", "25", "26", "27", "28", "29", "30", "31", "32", "33",
        "34", "35", "36", "37", "38", "39", "40", "41", "42", "43", "44", "45", "46", "47", "48", "49", "50", "51", "52", "53", "54", "55"]

    const listOptionsTamanoBusto = ["Seleccione", "Pequeños", "Medianos", "Grandes"]
    const listOptionsColorPiel = ["Seleccione", "Blanca", "Trigueña", "Morena", "Negra"]
    const listOptionsTamanoCola = ["Seleccione", "Pequeña", "Mediana", "Grande"]
    const listOptionsContextura = ["Seleccione", "Delgada", "Robusta", "Atlética"]

    // const listOptionsEstatura = ["Seleccione", "1,5 m", "1,6 m", "1,7 m", "1,8 m", "1,9 m", "2,0 m"]
    const listOptionsColorOjos = ["Seleccione", "Avellana", "Verde", "Azul", "Gris", "Castaño Ambar"]
    const listOptionsColorPelo = ["Seleccione", "Negro", "Castaño", "Rubio", "Peli Rojo"]

    const [check1, setCheck1] = useState(true);
    const [check2, setCheck2] = useState(true);
    const [check3, setCheck3] = useState(true);

    const listOptionsPrecio = [
        { label: "Seleccione", valor: "Seleccione" },
        { label: "$80.000", valor: 80000 },
        { label: "$100.000", valor: 100000 },
        { label: "$150.000", valor: 150000 },
        { label: "$200.000", valor: 200000 },
        { label: "$250.000", valor: 250000 },
        { label: "$300.000", valor: 300000 },
        { label: "$350.000", valor: 350000 },
        { label: "$400.000", valor: 400000 },
        { label: "$450.000", valor: 450000 },
        { label: "$500.000", valor: 500000 },
    ]

    const [edadDesdeList, setEdadDesdeList] = useState(["Seleccione"])
    const [edadHastaList, setEdadHastaList] = useState(["Seleccione"])

    const [precioDesdeList, setPrecioDesdeList] = useState([{ label: "Seleccione", valor: "0" }])
    const [precioHastaList, setPrecioHastaList] = useState([{ label: "Seleccione", valor: "0" }])

    const [edadDesde, setEdadDesde] = useState('Seleccione')
    const [edadHasta, setEdadHasta] = useState('Seleccione')

    const [precioDesde, setPrecioDesde] = useState(0)
    const [precioHasta, setPrecioHasta] = useState(0)

    const [tamanoBusto, setTamanoBusto] = useState("Seleccione")
    const [colorPiel, setColorPiel] = useState("Seleccione")

    const [tamanoCola, setTamanoCola] = useState("Seleccione")
    const [contextura, setContextura] = useState("Seleccione")

    const [colorOjos, setColorOjos] = useState("Seleccione")
    const [colorPelo, setColorPelo] = useState("Seleccione")

    useEffect(() => {
        setEdadDesdeList(listOptionsEdad)
        setPrecioDesdeList(listOptionsPrecio)
    }, [])

    const onSelectedEdadDesde = (e) => {
        setEdadDesde(e.target.value)
        if (e.target.value !== 'Seleccione') {
            setEdadHastaList(listOptionsEdad.filter((edad) => {
                return edad >= e.target.value
            }))
        } else {
            setEdadHastaList(["Seleccione"])
        }
    }

    const onSelectedPrecioDesde = (e) => {
        if (e.target.value === 'Seleccione') {
            setPrecioDesde(0)
            setPrecioHasta(0)
        } else {
            setPrecioDesde(e.target.value)
        }
        if (e.target.value !== '0') {
            setPrecioHastaList(listOptionsPrecio.filter((precio) => {
                return precio.valor >= e.target.value
            }))
        } else {
            setPrecioHastaList([{ label: "Seleccione", valor: "0" }])
        }
    }

    const onSelectedPrecioHasta = (e) => {
        if (e.target.value === 'Seleccione') {
            setPrecioHasta(0)
        } else {
            setPrecioHasta(e.target.value)
        }
    }

    const limpiarFiltrosAction = () => {
        setEdadDesde('Seleccione')
        setEdadHasta('Seleccione')
        setTamanoBusto("Seleccione")
        setPrecioDesde(0)
        setPrecioHasta(0)
        setEdadHastaList(["Seleccione"])
        setPrecioHastaList([{ label: "Seleccione", valor: "0" }])
        setColorPiel('Seleccione')
        setTamanoCola('Seleccione')
        setContextura('Seleccione')
        setColorOjos('Seleccione')
        setColorPelo('Seleccione')
        setCheck1(true)
        setCheck2(true)
        setCheck3(true)
    }

    const filtrarAction = () => {
        let listaErroresForm = [];
        if (edadDesde !== 'Seleccione') {
            if (edadHasta === 'Seleccione') {
                listaErroresForm.push("Falta edad maxima")
            }
        }
        if (precioDesde !== 0) {
            if (precioHasta === 0) {
                listaErroresForm.push("Falta precio maximo")
            }
        }

        if (listaErroresForm.length === 0) {
            setOpenMenuFilter(false)
            filtersActionService()
        } else {
            listaErroresForm.forEach((valorE) => {
                toast(valorE)
            })
        }
    }

    const filtersActionService = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "edadDesde": edadDesde,
                "edadHasta": edadHasta,
                "tamanoBusto": tamanoBusto,
                "precioDesde": precioDesde,
                "precioHasta": precioHasta,
                "colorPiel": colorPiel,
                "tamanoCola": tamanoCola,
                "contextura": contextura,
                "perfil1": check1,
                "perfil2": check2,
                "perfil3": check3,
                "colorOjos": colorOjos,
                "colorPelo": colorPelo
            }
            const response = await authServices.requestPost(body, 2);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setControlLoadTarjetScort(false)
                setScortObjectList(objeto)
                setTimeout(() => {
                    setControlLoadTarjetScort(true)
                    setCargando(false)
                }, 150)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false)
            toast('Error de comunicación')
        }

    }

    return (
        <>
            <div className="div-container-filtros">
                <div className="div-container-filtros-hijo">
                    <div className="row m-0">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className='margin-div-filtros'>
                                <div className="row m-0">
                                    <div className="col-12">
                                        <p className='p-label-filtro' >Edad:</p>
                                    </div>
                                    <div className="col-6 padding-row-response-1"  >
                                        <div className="div-field-filter" >
                                            <p >Edad minima:</p>
                                            <select value={edadDesde} className='form-control' onChange={(e) => { onSelectedEdadDesde(e) }} >
                                                {
                                                    edadDesdeList.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key}>{key}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-6 padding-row-response-2">
                                        <div className="div-field-filter" >
                                            <p className=''>Edad Maxima:</p>
                                            <select value={edadHasta} className='form-control' onChange={(e) => setEdadHasta(e.target.value)} >
                                                {
                                                    edadHastaList.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key}>{key}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6"  >
                            <div className='margin-div-filtros'>
                                <div className="row m-0" >
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <p className='p-label-filtro' >Busto:</p>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3"></div>
                                    <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0">
                                        <p className=''>Tamaño busto</p>
                                        <select className='form-control' value={tamanoBusto} onChange={(e) => setTamanoBusto(e.target.value)}>
                                            {
                                                listOptionsTamanoBusto.map((key, i) => {
                                                    return (
                                                        <option key={i} value={key}>{key}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-3 col-lg-3"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br className='br-filter-fields' />
                    <div className='margin-div-filtros'>
                        <div className="row m-0">
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div className="row m-0">
                                    <div className="col-12"  >
                                        <p className='p-label-filtro' >Precio:</p>
                                    </div>
                                    <div className="col-6 padding-row-response-1">
                                        <div className="div-field-filter" >
                                            <p >Precio desde:</p>
                                            <select className='form-control' value={precioDesde} onChange={(e) => onSelectedPrecioDesde(e)} >
                                                {
                                                    precioDesdeList.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key.valor}>{key.label}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                    <div className="col-6 padding-row-response-2">
                                        <div className="div-field-filter" >
                                            <p className=''>Precio hasta:</p>
                                            <select className='form-control' value={precioHasta} onChange={(e) => onSelectedPrecioHasta(e)}>
                                                {
                                                    precioHastaList.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key.valor}>{key.label}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6"  >
                                <div className='margin-div-filtros'>
                                    <div className="row m-0" >
                                        <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                            <p className='p-label-filtro' >Piel:</p>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3 col-lg-3"></div>
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 p-0">
                                            <p className=''>Color de piel:</p>
                                            <select className='form-control' value={colorPiel} onChange={(e) => setColorPiel(e.target.value)}>
                                                {
                                                    listOptionsColorPiel.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key}>{key}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                        <div className="col-12 col-sm-12 col-md-3 col-lg-3"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br className='br-filter-fields' />
                    <div className="row m-0">
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className="row m-0">
                                <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                    <br className='br-filter-fields' />
                                </div>
                                <div className="col-6 padding-row-response-1">
                                    <div className='margin-div-filtros'>
                                        <p className='p-label-filtro-2' >Tamaño cola:</p>
                                        <select className='form-control' value={tamanoCola} onChange={(e) => setTamanoCola(e.target.value)} >
                                            {
                                                listOptionsTamanoCola.map((key, i) => {
                                                    return (
                                                        <option key={i} value={key}>{key}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                                <div className="col-6 padding-row-response-2">
                                    <div className='margin-div-filtros'>
                                        <p className=''>Contextura:</p>
                                        <select className='form-control' value={contextura} onChange={(e) => setContextura(e.target.value)}>
                                            {
                                                listOptionsContextura.map((key, i) => {
                                                    return (
                                                        <option key={i} value={key}>{key}</option>
                                                    )
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                            <div className='margin-div-filtros'>
                                <div className="row m-0" >
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <p className='p-label-filtro' >Perfil:</p>
                                        <br className='br-filter-fields' />
                                    </div>
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12 p-0">
                                        <div className="div-checks-perfil" >
                                            <div class="form-check">
                                                <button className={check1 ? 'btn btn-link btn-checks-perfil-active' : 'btn btn-link btn-checks-perfil'} onClick={() => setCheck1(!check1)}>
                                                    Escort
                                                </button>
                                            </div>
                                            <div class="form-check">
                                                <button className={check2 ? 'btn btn-link btn-checks-perfil-active' : 'btn btn-link btn-checks-perfil'} onClick={() => setCheck2(!check2)}>
                                                    Acompañante
                                                </button>
                                            </div>
                                            <div class="form-check">
                                                <button className={check3 ? 'btn btn-link btn-checks-perfil-active' : 'btn btn-link btn-checks-perfil'} onClick={() => setCheck3(!check3)}>
                                                    Call Girls
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <br className='br-filter-fields' />
                    <div className='margin-div-filtros'>
                        <div className="row m-0">
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div className="row m-0">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <br className='br-filter-fields' />
                                    </div>
                                    <div className="col-12 p-0">
                                        <div className='margin-div-filtros'>
                                            <p className='p-label-filtro-2' >Color de ojos:</p>
                                            <select className='form-control' value={colorOjos} onChange={(e) => setColorOjos(e.target.value)} >
                                                {
                                                    listOptionsColorOjos.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key}>{key}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-12 col-sm-12 col-md-6 col-lg-6"  >
                                <div className="row m-0">
                                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                                        <br className='br-filter-fields' />
                                    </div>
                                    <div className="col-12 p-0">
                                        <div className='margin-div-filtros'>
                                            <p className='p-label-filtro-2' >Color de pelo:</p>
                                            <select className='form-control' value={colorPelo} onChange={(e) => setColorPelo(e.target.value)} >
                                                {
                                                    listOptionsColorPelo.map((key, i) => {
                                                        return (
                                                            <option key={i} value={key}>{key}</option>
                                                        )
                                                    })
                                                }
                                            </select>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row m-0">
                <div className="col-12 col-sm-12 col-md-6 col-lg-6" ></div>
                <div className="col-12 col-sm-12 col-md-6 col-lg-6" >
                    <div className='margin-div-filtros-buttoms'>
                        <div className="row m-0" >
                            <div className="col-1 col-sm-2 col-md-12 col-lg-1 m-0 p-0" ></div>
                            <div className="col-4 col-sm-3 col-md-3 col-lg-3 m-0 p-0" style={{ textAlign: "end" }}>
                                <button className='btn btn-link btn-filters' onClick={() => filtrarAction()} >
                                    Buscar
                                </button>
                            </div>
                            <div className="col-6 col-sm-5 col-md-6 col-lg-5 m-0 p-0" style={{ textAlign: "end" }}>
                                <button className='btn btn-link btn-filters' onClick={() => limpiarFiltrosAction()} >
                                    Limpiar Filtros
                                </button>
                            </div>
                            <div className="col-1 col-sm-2 col-md-3 col-lg-3 m-0 p-0" ></div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Filtros